<template>
  <b-row class="d-flex my-4 border-bottom pb-2">
    <b-col class="order-2 order-md-1 my-2" cols="12" md="6">
      <h1 class="my-auto mb-2">{{ title }}</h1>
      <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    </b-col>
    <b-col
      v-if="!$route.path.includes('edit') && !$route.path.includes('create')"
      class="order-1 order-md-2 d-flex justify-content-md-end justify-content-center align-items-end m-auto"
      cols="12"
      md="6"
    >
      <b-button
        class="subnavbtn button my-auto"
        :to="{ name: 'buildings' }"
        :class="[$route.name == 'buildings' ? 'btn-green' : 'btn-grey']"
      >
        <font-awesome-icon class="agv-button-icon" icon="building" />
        <span>{{ $t("catalogs.buildings") }}</span>
      </b-button>

      <b-button
        class="subnavbtn button my-auto"
        :to="{ name: 'resolutions-catalogs' }"
        :class="[$route.name == 'resolutions-catalogs' ? 'btn-green' : 'btn-grey']"
      >
        <font-awesome-icon class="agv-button-icon" icon="th-list" />
        <span>{{ $t("catalogs.resolutions") }}</span>
      </b-button>

      <b-button
        class="subnavbtn button my-auto"
        :to="{ name: 'majorities' }"
        :class="[$route.name == 'majorities' ? 'btn-green' : 'btn-grey']"
      >
        <font-awesome-icon class="agv-button-icon" icon="sitemap" />
        <span>{{ $t("catalogs.majorities") }}</span>
      </b-button>
      <!-- <b-nav>
        <b-nav-item :to="{ name: 'buildings' }">
          <font-awesome-icon icon="building" />
          <span class="nav-item-text">Buildings</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'majorities' }">
          <font-awesome-icon icon="sitemap" />
          <span class="nav-item-text">Majorities</span>
        </b-nav-item>
      </b-nav> -->
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    breadcrumbLast: {
      type: String,
      default: "",
    },
    breadcrumbRouteText: {
      type: String,
      default: "",
    },
    breadcrumbRouteName: {
      type: String,
      default: "",
    },
  },
  computed: {
    breadcrumbs() {
      if (!this.$route.path.includes("edit") && !this.$route.path.includes("create")) {
        return [
          {
            text: this.$t("catalogs.home"),
            to: {
              name: "home",
            },
          },
          {
            text: this.$t("catalogs.catalogs"),
            to: {
              name: "catalogs",
            },
          },
          {
            text: this.breadcrumbLast,
            active: true,
          },
        ];
      } else {
        return [
          {
            text: this.$t("catalogs.home"),
            to: {
              name: "home",
            },
          },
          {
            text: this.$t("catalogs.catalogs"),
            to: {
              name: "catalogs",
            },
          },
          {
            text: this.breadcrumbRouteText,
            to: {
              name: this.breadcrumbRouteName,
            },
          },
          {
            text: this.breadcrumbLast,
            active: true,
          },
        ];
      }
    },
  },
};
</script>
